import React from "react"

export const Rate = ({ opening }) => {
  const { tutor_rate } = opening
  return tutor_rate ? (
    <div className="text-right font-size-big font-weight-semibold">{`$${parseFloat(tutor_rate).toFixed(2)}/hr`}</div>
  ) : null
}
